import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import {isRefundable, numberWithCommas} from '../../helpers';
import {connect} from 'react-redux';

const Flight = ({ flight, onViewDetails, searchDetails }) => {
	const airline = flight.Airline || flight.airline || 'Airline';
	return (
		<div
			className="flight-card card"
			role="button"
			tabIndex={0}
			key={flight.FlightNo}
			onClick={() => onViewDetails('OUTBOUND', flight)}
			onKeyDown={(e) => {
				if (e.key === 'Enter' || e.key === ' ') {
					e.preventDefault();
					onViewDetails('OUTBOUND', flight);
				}
			}}
		>
			<div className="flight-card__inner d-flex justify-content-between align-items-center">
				<div className="flight-card__airline col-3 col-md-2 p-1 text-center">
					<img src={flight.AirlineLogo} alt="" className="airline-logo" />
					<div className="flight-card__airline-name text-small text-muted">{airline}</div>
				</div>
				<div className="flight-card__times col-6 col-md-7 no-padding">
					<div className='d-flex justify-content-between'>
						<span className='text-bold'>{flight.DepartureTime}</span>
						<i className='fas fa-clock text-muted' />
						<span className='text-bold'>{flight.ArrivalTime}</span>
					</div>
					<div className='d-flex justify-content-between'>
						<span className='text-small text-muted'>{searchDetails.strSectorFrom}</span>
						<div className='text-small flex-grow-1 text-center lined'>{flight.duration} min</div>
						<span className='text-small text-muted'>{searchDetails.strSectorTo}</span>
					</div>
				</div>
				<div className="flight-card__fare col-3 no-padding text-center">
					<div className=''>
						{flight.Currency}:&nbsp;
						<span className='text-strong'>{numberWithCommas(flight.total_fare)}</span>
						<div className='text-smaller text-muted'>{isRefundable(flight.Refundable)}</div>
					</div>
				</div>
			</div>
		</div>
	);
};

const mapStateToProps = ({flightStore}) => ({
	searchDetails: flightStore.searchDetails
});

const mapDispatchToProps = () => ({});

export default connect(mapStateToProps, mapDispatchToProps)(Flight);
